
const TokenKey = 'access_token'

export const getItem = item => { // 读取
  return sessionStorage.getItem(item)
}

export const setItem = (item, value) => { // 储存
  sessionStorage.setItem(item, value)
}

export const removeItem = item => { // 删除
  sessionStorage.removeItem(item)
}

export const localStorageGetItem = item => { // 读取
  return localStorage.getItem(item)
}

export const localStorageSetItem = (item, value) => { // 保存
  localStorage.setItem(item, value)
}

export const localStorageRemoveItem = item => { // 删除
  localStorage.removeItem(item)
}
